import React from "react";
import axios from "axios";
import Loading from "./Loading";
import ManagerBusList from "./ManagerBusList";
import ManagerCampaignList from "./ManagerCampaignList";

function ManagerView() {
  const [campaign, setCampaign] = React.useState(undefined);
  //const [product, setProduct] = React.useState(undefined);
  const [bus, setBus] = React.useState(undefined);
  const [ads, setAds] = React.useState([]);
  const [tapes, setTapes] = React.useState(undefined);
  const [tab, setTab] = React.useState("campaigns");
  const [loading, setLoading] = React.useState(true);
  const [reload, setReload] = React.useState(true);
  const [search, setSearch] = React.useState({ buses: "", campaigns: "" });

  React.useEffect(() => {
    setLoading(true);
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/getAds")
      .then((res) => {
        setAds(res.data.ads);
        setTapes(res.data.tapes);
        setLoading(false);
      })
      .catch((reason) => {
        console.log("/getAds failed", reason);
        alert("Datan haku epäonnistui \nVirheviesti:" + reason.message);
      });
  }, [reload]);
  return (
    <div>
      <div className={"tabSelectionContainerHorizontal"}>
        <div
          className={
            tab === "campaigns" ? "tabSelectionActive" : "tabSelectionInactive"
          }
          onClick={() => {
            setTab("campaigns");
          }}
        >
          Kampanjat
        </div>
        <div
          className={
            tab === "buses" ? "tabSelectionActive" : "tabSelectionInactive"
          }
          onClick={() => {
            setTab("buses");
          }}
        >
          Bussit
        </div>
      </div>
      {loading ? <Loading /> : ""}
      {tab === "buses" ? (
        <ManagerBusList
          ads={ads}
          tapes={tapes}
          bus={bus}
          setBus={setBus}
          search={search}
          setSearch={setSearch}
          reload={reload}
          setReload={setReload}
        />
      ) : tab === "campaigns" ? (
        <ManagerCampaignList
          ads={ads}
          tapes={tapes}
          campaign={campaign}
          setCampaign={setCampaign}
          search={search}
          setSearch={setSearch}
          setBus={setBus}
          setTab={setTab}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default ManagerView;
